export default "__VITE_ASSET__4059b8d7__"